import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { SetAnswersValue } from "../../../../../redux/slice/SurveySlice/AnswerSlice";
import { SetInputFocus } from "../../../../../redux/slice/SurveySlice/SurveySlice";
import { AiOutlineCheckSquare } from "react-icons/ai";
export default function ShortAnswer({
  questionsindex,
  answers,
  onChangeSingle,
  onFocusInput,
  InputAnswersFontScales
}) {

  const dispatch = useDispatch();
  const [value, setvalue] = useState("");
  const [ChangeVsblty, setChangeVsblty] = useState(false);

  function onChangeAnswer(value) {
    setChangeVsblty(true);
    setvalue(value);
    dispatch(SetAnswersValue({ index: questionsindex, value }));
  }
  return (
    <>
      <div className="w-full  h-full flex mt-2 items-center justify-center relative">
        <div class="form-control w-full h-full">
          <label class="label">
            <span class="label-text"></span>

            <span class="label-text-alt">
              {value.length > 0 && ChangeVsblty === true ? (
                <AiOutlineCheckSquare
                  onClick={() => (onChangeSingle(), setChangeVsblty(false))}
                  className="text-green-700 absolute -top-14 right-0 hover:text-green-900 cursor-pointer"
                  size={40}
                />
              ) : (
                ""
              )}
            </span>
          </label>
          <textarea
            maxLength={36000}
            disabled={answers !== undefined ? true : false}
            className={`textarea w-full h-40  mb-10 bg-black/5 placeholder:text-black border-black/10 border-2 ${InputAnswersFontScales}`}
            placeholder={
              answers !== undefined
                ? ""
                : "Soruya vereceğiniz cevabı buraya yazınız"
            }
            onFocus={() => (
              dispatch(SetInputFocus(true)),
              setChangeVsblty(true),
              onFocusInput()
            )}
            onBlur={() =>
              setTimeout(() => {
                dispatch(SetInputFocus(false));
                setChangeVsblty(false);
              }, 100)
            }
            onChange={(e) => onChangeAnswer(e.target.value)}
            value={answers !== undefined ? answers : value}
          ></textarea>
        </div>
      </div>
    </>
  );
}
